var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.authenticated)?_c('AuthenticationView',{key:"authentication"}):_c('DashboardLoader',{key:"dashboard"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }